import { createEntityAdapter } from '@reduxjs/toolkit';

import { Message } from './types/Message';

export const messagesAdapter = createEntityAdapter<Message>();
